import React, { useEffect, useRef } from 'react';

export const SearchAndFilter = ({
  searchTerm,
  setSearchTerm,
  sortBy,
  setSortBy,
  placeholder = "Search events by name, venue, or type...",
  showSort = true,
  searchKey = 0,
  autoFocus = true
}) => {
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchKey, autoFocus]);

  return (
    <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 shadow-xl border border-gray-200 mb-10">
      <div className="flex flex-col lg:flex-row gap-4 items-center">
        <div className="flex-1 w-full">
          <div className="relative group">
            <input
              key={`search-input-${searchKey}`}
              ref={searchInputRef}
              type="text"
              placeholder={placeholder}
              className="w-full pl-12 pr-4 py-3.5 border-2 border-gray-200 rounded-xl focus:border-blue-500 focus:ring-0 outline-none bg-white shadow-sm text-lg transition-all duration-300 group-hover:border-blue-300"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
              <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-blue-400 rounded-lg flex items-center justify-center shadow-md">
                <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        {showSort && (
          <div className="relative group min-w-[200px]">
            <select
              className="w-full px-4 py-3.5 pl-10 border-2 border-gray-200 rounded-xl focus:border-purple-500 focus:ring-0 bg-white shadow-sm appearance-none cursor-pointer transition-all duration-300 group-hover:border-purple-300"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="name">Sort by Name</option>
              <option value="date">Sort by Date</option>
              <option value="participants">Sort by Participants</option>
              <option value="amount">Sort by Amount</option>
            </select>
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4" />
              </svg>
            </div>
            <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};